import { render } from "./titleBar.vue?vue&type=template&id=116827ba&scoped=true"
import script from "./titleBar.vue?vue&type=script&lang=js"
export * from "./titleBar.vue?vue&type=script&lang=js"

import "./titleBar.vue?vue&type=style&index=0&id=116827ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-116827ba"]])

export default __exports__